"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersectsLineString = intersectsLineString;
exports.intersectsLineStringArray = intersectsLineStringArray;
exports.intersectsLinearRing = intersectsLinearRing;
exports.intersectsLinearRingArray = intersectsLinearRingArray;
exports.intersectsLinearRingMultiArray = intersectsLinearRingMultiArray;

var _extent = require("../../extent.js");

var _segments = require("./segments.js");

var _contains = require("./contains.js");

/**
 * @module ol/geom/flat/intersectsextent
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLineString(flatCoordinates, offset, end, stride, extent) {
  var coordinatesExtent = (0, _extent.extendFlatCoordinates)((0, _extent.createEmpty)(), flatCoordinates, offset, end, stride);

  if (!(0, _extent.intersects)(extent, coordinatesExtent)) {
    return false;
  }

  if ((0, _extent.containsExtent)(extent, coordinatesExtent)) {
    return true;
  }

  if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) {
    return true;
  }

  if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) {
    return true;
  }

  return (0, _segments.forEach)(flatCoordinates, offset, end, stride,
  /**
   * @param {import("../../coordinate.js").Coordinate} point1 Start point.
   * @param {import("../../coordinate.js").Coordinate} point2 End point.
   * @return {boolean} `true` if the segment and the extent intersect,
   *     `false` otherwise.
   */
  function (point1, point2) {
    return (0, _extent.intersectsSegment)(extent, point1, point2);
  });
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */


function intersectsLineStringArray(flatCoordinates, offset, ends, stride, extent) {
  for (var i = 0, ii = ends.length; i < ii; ++i) {
    if (intersectsLineString(flatCoordinates, offset, ends[i], stride, extent)) {
      return true;
    }

    offset = ends[i];
  }

  return false;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */


function intersectsLinearRing(flatCoordinates, offset, end, stride, extent) {
  if (intersectsLineString(flatCoordinates, offset, end, stride, extent)) {
    return true;
  }

  if ((0, _contains.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[1])) {
    return true;
  }

  if ((0, _contains.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[0], extent[3])) {
    return true;
  }

  if ((0, _contains.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[1])) {
    return true;
  }

  if ((0, _contains.linearRingContainsXY)(flatCoordinates, offset, end, stride, extent[2], extent[3])) {
    return true;
  }

  return false;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */


function intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent) {
  if (!intersectsLinearRing(flatCoordinates, offset, ends[0], stride, extent)) {
    return false;
  }

  if (ends.length === 1) {
    return true;
  }

  for (var i = 1, ii = ends.length; i < ii; ++i) {
    if ((0, _contains.linearRingContainsExtent)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
      if (!intersectsLineString(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        return false;
      }
    }
  }

  return true;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */


function intersectsLinearRingMultiArray(flatCoordinates, offset, endss, stride, extent) {
  for (var i = 0, ii = endss.length; i < ii; ++i) {
    var ends = endss[i];

    if (intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent)) {
      return true;
    }

    offset = ends[ends.length - 1];
  }

  return false;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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